import React, {useState} from 'react'
import {NavLink, withRouter} from 'react-router-dom'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CRow
} from '@coreui/react'

import {
  INCORRECT_LOGIN_MSG,
  NO_CODE_RECEIVED_MSG,
  UNABLE_TO_AUTHORIZE_MSG,
  MFACODE,
  POOL,
  SESSION,
  USERNAME,
  ACCESSTOKEN
} from '../../../AppConstants';
import {v4 as uuidv4} from 'uuid';
import {setLoggedInUser, clearLoggedInUser} from '../../../actions';
import store from "../../../store";
import {invokeAuthorization} from "../../../auth/Authorization";

async function invokeAuthentication(url, request) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-request-id': uuidv4()
    },
    body: JSON.stringify(request)
  })
  .then(data => data.json())
  .catch(error => {
    console.log('VerifyCode caught error:', error);
  });
}

const VerifyCode = (props) => {
  const [mfaCode, setMfaCode] = useState("");
  const [message, setMessage] = useState("");

  const handleFieldChange = (event) => {
    const {value} = event.target;
    setMfaCode(value);
  }

  const handleDidNotReceiveCode = (event) => {
    event.preventDefault();
    store.dispatch(clearLoggedInUser());
    props.history.push({pathname: "/Login"});
  }

  const handleVerifyCode = (event) => {
    event.preventDefault();
    setMessage("");

    // explicitly invoke form validation as preventDefault skips it
    let ele = document.getElementById("verifyCodeForm");
    let areFieldsValid = ele.checkValidity();
    ele.reportValidity();
    if (areFieldsValid) {
      performVerifyCode();
    }
  }

  const performVerifyCode = async () => {
    let request = {
      [USERNAME]: store.getState()?.userSession?.username,
      [MFACODE]: mfaCode,
      [SESSION]: store.getState()?.userSession?.session,
      [POOL]: process.env.REACT_APP_SESSION_POOL_NAME
    }
    console.log(
      `Submitting MFA verification request for: ${store.getState()?.userSession?.username}`);

    const token = await invokeAuthentication(
      process.env.REACT_APP_SESSION_VERIFY_MFA_CODE_URL, request);

    if (token?.success) {
      // call Authorization
      let requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-request-id': uuidv4()
        },
        body: JSON.stringify({
          [ACCESSTOKEN]: token?.accessToken,
          [POOL]: process.env.REACT_APP_SESSION_POOL_NAME
        })
      };

      const authorizeResponse = await invokeAuthorization(
        process.env.REACT_APP_SESSION_AUTHORIZATION_URL, requestOptions);

      if (authorizeResponse?.success) {
        let userSession = {
          'token': token?.accessToken,
          'merchant': authorizeResponse?.merchant,
          'username': store.getState()?.userSession?.username
        };
        store.dispatch(setLoggedInUser(userSession));
        props.history.push({pathname: "/dashboard"});
      } else {
        setMfaCode("");
        store.dispatch(clearLoggedInUser());
        props.history.push({
          pathname: "/login",
          state: UNABLE_TO_AUTHORIZE_MSG
        });
      }
    } else {
      setMfaCode("");
      store.dispatch(clearLoggedInUser());
      props.history.push({
        pathname: "/login",
        state: INCORRECT_LOGIN_MSG
      });
    }
  }

  return (
    <div
      className="c-app c-default-layout flex-row align-items-center verifyCodePage">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol>
            <CCardGroup className="publicCardGroup">
              <CCard className="p-4 leftImage">
                <CCardBody>
                </CCardBody>
              </CCard>
              <CCard>
                <CCardBody>
                  <CForm id="verifyCodeForm">
                    <div className="loginLogo"/>
                    <div className="text-muted-two-step">Two Step Verification
                    </div>
                    <div className="text-muted-enter-verify-code">Enter the verification
                      code that was sent to your mobile device
                    </div>
                    {message &&
                    <div className="invalidField">{message}</div>
                    }
                    <CInputGroup className="mb-3">
                      <CInput type="text"
                              placeholder="Verification Code"
                              name="mfaCode"
                              value={mfaCode}
                              onChange={handleFieldChange}
                              minLength="6"
                              maxLength="6" required/>
                    </CInputGroup>
                    <CRow className="buttonArea">
                      <CCol xs="3"/>
                      <CCol xs="6">
                        <CButton color="primary"
                                 type="submit"
                                 className="px-4 btn-lg btn-block"
                                 onClick={handleVerifyCode}>Submit</CButton>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol xs="2"/>
                      <CCol xs="9">
                        <CButton>
                          <NavLink to="#" className="text-not-received-code" onClick={handleDidNotReceiveCode}><u>{NO_CODE_RECEIVED_MSG}</u></NavLink>
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default withRouter(VerifyCode);
